export const formatDate = (
  dateString: string,
  format: 'date' | 'time' | 'dateNumeric' | 'dateTime' | 'dateTimeFull' | 'dateShort' | 'default'
): string => {
  const date = new Date(dateString);

  let formattedDate;

  switch (format) {
    case 'date':
      // example: January 1, 2022
      formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC', // Adjust as needed
      });
      break;
    case 'time':
      formattedDate = new Intl.DateTimeFormat('en-US', { timeStyle: 'short' });
      break;
    case 'dateNumeric':
      formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
      });
      break;
    case 'dateTime':
      formattedDate = new Intl.DateTimeFormat('en-US', { dateStyle: 'short', timeStyle: 'short' });
      break;
    case 'dateTimeFull': {
      formattedDate = new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' });
      const timeFormat = new Intl.DateTimeFormat('en-US', { timeStyle: 'medium' });
      return `${formattedDate?.format(date)} | ${timeFormat?.format(date)}`;
    }
    case 'dateShort':
      // example: Jan 1, 2022
      formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC', // Adjust as
      });
      break;
    default:
      // example: Jan 1, 2022, 12:00:00 PM
      formattedDate = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true, // Use `false` for 24-hour format
        timeZone: 'UTC', // Adjust as needed
      });
  }
  return formattedDate?.format(date) ?? '';
};

export const formatDateAsString = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${month}/${day}/${year}`;
};
